module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ypyx-dialog-wrap"
  }, [(!(_vm.cvipMes.cvipstate == 1 || _vm.cvipMes.cvipstate == 10)) ? _c('CvipDialog', {
    attrs: {
      "title": _vm.title,
      "btnTxt": _vm.btnTxt
    },
    on: {
      "btnClick": function($event) {
        return _vm.vipBuy()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('p', {
    staticClass: "des"
  }, [_vm._v("特权介绍："), _c('span', {
    staticClass: "des-in"
  }, [_vm._v("简历投递石沉大海？投递的简历收到的反馈极慢？已经找到工作，之前投递的公司才联系你？加入会员，你主动投递的全职简历将在企业后台置顶展示，让企业在挑选人才时第一时间看到你，让你快速得到企业反馈。")])]), _vm._v(" "), _c('div', {
    staticClass: "ypyx-bg"
  }, [_c('img', {
    staticClass: "ypyx-bg-img",
    attrs: {
      "src": require("../../../../assets/imgs/pri-ypyx.png")
    }
  })])]) : _c('CvipDialog', {
    attrs: {
      "title": _vm.title1,
      "btnTxt": _vm.btnTxt1
    },
    on: {
      "btnClick": function($event) {
        return _vm.vipBuy()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('p', {
    staticClass: "tit"
  }, [_vm._v("恭喜您，已获得"), _c('span', {
    staticClass: "tit-names"
  }, [_vm._v("应聘优先")]), _vm._v("特权")]), _vm._v(" "), _c('p', {
    staticClass: "des"
  }, [_c('span', {
    staticClass: "des-in des-use"
  }, [_vm._v("特权介绍：简历投递石沉大海？投递的简历收到的反馈极慢？已经找到工作，之前投递的公司才联系你？加入会员，你主动投递的全职简历将在企业后台置顶展示，让企业在挑选人才时第一时间看到你，让你快速得到企业反馈。")])]), _vm._v(" "), _c('div', {
    staticClass: "ypyx-bg"
  }, [_c('img', {
    staticClass: "ypyx-bg-img",
    attrs: {
      "src": require("../../../../assets/imgs/pri-ypyx.png")
    }
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-de8430ce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/index/modules/dialog/YpyxDialog.vue
// module id = ADMS
// module chunks = 1